export const CATEGORY_COLORS = {
  confirmation: { bg: '#d4edda', color: '#155724' },
  reminder: { bg: '#fff3cd', color: '#856404' },
  payment: { bg: '#d1ecf1', color: '#0c5460' },
  promo: { bg: '#e3f2fd', color: '#1976d2' },
  other: { bg: '#f3e5f5', color: '#7b1fa2' },
};

export const EVENT_TYPE_COLORS = {
  reservation_approved: { bg: '#d4edda', color: '#155724' },
  reservation_rejected: { bg: '#f8d7da', color: '#721c24' },
  reservation_created: { bg: '#d1ecf1', color: '#0c5460' },
  reservation_cancelled: { bg: '#fff3cd', color: '#856404' },
  reservation_message: { bg: '#e3f2fd', color: '#1976d2' },
  payment_received: { bg: '#d4edda', color: '#155724' },
  checkin_minus_1d: { bg: '#fff3cd', color: '#856404' },
  checkin_minus_3d: { bg: '#fff3cd', color: '#856404' },
  checkin_minus_7d: { bg: '#fff3cd', color: '#856404' },
  checkout_minus_1d: { bg: '#ffe0cc', color: '#c0392b' },
  payment_due_minus_3d: { bg: '#fce4ec', color: '#c62828' },
  payment_due_minus_7d: { bg: '#fce4ec', color: '#c62828' },
};

export function getCategoryStyle(category) {
  return CATEGORY_COLORS[category] || CATEGORY_COLORS.other;
}

export function getEventTypeStyle(eventType) {
  return EVENT_TYPE_COLORS[eventType] || { bg: '#e3f2fd', color: '#1565c0' };
}
